import React from 'react';

import { Image } from '@change/ds-core-ui';

import { useImageAttribution } from './hooks/useImageAttribution';

export const ImageWithAttribution: React.FC<{ imgAlt: string }> = ({ imgAlt }) => {
	const {
		data: { imgHref },
	} = useImageAttribution();

	if (!imgHref) {
		return null;
	}

	return (
		<div className="z-0 h-[242px] md:h-full xl:h-[400px]">
			<div className="relative h-full w-full">
				<Image className="h-full w-full object-cover" src={imgHref} alt={imgAlt} />
			</div>
		</div>
	);
};
